import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { RequestCloudFileCloudFixRequest } from "../../../../../common/api/master-api/cloud-files/cloud-fix/request/RequestCloudFileCloudFixRequest";
import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileQueryKey } from "../../../details/common/CloudFileQueryKey";

export interface UseRequestCloudFileFix {
    requestCloudFileFix: SprintMutationResult<RequestCloudFileCloudFixRequest, void>;
}

export const useRequestCloudFileFix = ({ invalidationKey }: { invalidationKey?: string }): UseRequestCloudFileFix => {
    const cloudFileApi = useCloudFileApi();
    const sprintQueryClient = useSprintQueryClient();

    const requestCloudFileFix = useSprintMutation<RequestCloudFileCloudFixRequest>({
        mutationFn: async ({ cloudFileId, filename, cloudAssetId }: RequestCloudFileCloudFixRequest) => {
            if (!cloudFileId) {
                throw new Error("Cloud File ID is required to approve buzz notifications.");
            }

            return cloudFileApi.requestCloudFix({ cloudFileId, filename, cloudAssetId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudFileQueryKey.CloudFileDetails, invalidationKey]
            });
        }
    });

    return {
        requestCloudFileFix
    };
};
